import { useCallback, useEffect } from 'preact/hooks';
import { getServicesByVariantId } from '@/api';
import { useServiceStore } from '@/contexts/service-context';
import { log } from '@/utils';

export const useOptionChangeEvent = () => {
  const { setVariantId, setServices, setActiveOfferingByServiceId } =
    useServiceStore();

  const fetchOfferingsByVariantId = useCallback(
    async (event: Event) => {
      const detail = (event as CustomEvent<{ v3_variant_id: number | null }>)
        .detail;
      const variantId = detail.v3_variant_id;

      if (!variantId) {
        setVariantId(null);
        setActiveOfferingByServiceId();
        setServices(null);
        return;
      }

      const services = await getServicesByVariantId(variantId);
      setVariantId(variantId);
      setServices(services?.length ? services : null);
    },
    [setVariantId, setServices, setActiveOfferingByServiceId],
  );

  useEffect(() => {
    window.itsServices?.events.on(
      'product-options-change',
      fetchOfferingsByVariantId,
    );

    onInitTriggerOptionChange();

    return () => {
      window.itsServices?.events.off(
        'product-options-change',
        fetchOfferingsByVariantId,
      );
    };
  }, []);
};

const onInitTriggerOptionChange = () => {
  if (!window.stencilUtils) {
    log.error('Stencil Utils not found');
    return;
  }

  const form = document.querySelector(
    '.productView [data-cart-item-add]',
  ) as HTMLFormElement;
  const serialized = serializeForm(form);
  const productId = parseInt(
    (form.querySelector('[name="product_id"]') as HTMLInputElement)?.value ||
      '0',
    10,
  );

  window.stencilUtils.api.productAttributes.optionChange(
    productId,
    serialized,
    'products/bulk-discount-rates',
    (_, res) => {
      window.itsServices?.events.emit('product-options-change', {
        ...res.data,
      });
    },
  );
};

const serializeForm = (form: HTMLFormElement) => {
  const formData = new FormData(form);
  const params = new URLSearchParams();

  formData.forEach((value, key) => {
    params.append(key, value.toString());
  });

  return params.toString();
};
